class LandinPageProductTestimonials extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = this;
    this.swiper = this.section.querySelector(".swiper");
    this.pagination = this.section.querySelector(".swiper-pagination");

    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Pagination } = _ref;
      this.slider = new Swiper(this.swiper, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: this.pagination,
          type: "bullets",
          bulletElement: "span",
          bulletClass: "swiper-pagination-bullet",
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
    });
  }
  disconnectedCallback() {}
}
customElements.define(
  "landing-page-product-testimonials",
  LandinPageProductTestimonials
);
